import React from "react";
import style from "./Filter.module.scss";

const Filter = ({ placeholder, filter, options, onChange, onChangeSelect }) => {
  return (
    <div className={style.container}>
      <input
        type='text'
        onChange={onChange}
        placeholder='Search'
        className={style.field}
      />
      <select value={filter} onChange={onChangeSelect} className={style.btn}>
        <option value=''>{placeholder}</option>
        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Filter;
